import { FormErrors } from 'redux-form';
import { rutValidator } from '../helpers/utils';
import { calculateAge, chargesToArray } from './utils';

const regexDate = /^((0?[1-9]|[12][0-9]|3[01])[- /.](0?[1-9]|1[012])[- /.](19|20)?[0-9]{2})*$/i;
const regexString = /^[A-Za-zÀ-ÿÑñ\-' ]+$/i;

const validation = (values: any) => {
  const errors: FormErrors<any> = {};

  const chargesCount = chargesToArray(values.charges);

  chargesCount.map(index => {
    const ageValue = values[`charge-birthdate-${index}`];
    const { days, years } = calculateAge(ageValue);

    if (!values[`charge-documentId-${index}`]) {
      errors[`charge-documentId-${index}`] = 'Campo obligatorio';
    } else if (!rutValidator(values[`charge-documentId-${index}`])) {
      errors[`charge-documentId-${index}`] = 'Rut inválido';
    }

    if (!values[`charge-name-${index}`]) {
      errors[`charge-name-${index}`] = 'Campo obligatorio';
    } else if (!regexString.test(values[`charge-name-${index}`])) {
      errors[`charge-name-${index}`] =
        'El nombre no puede contener números ni caracteres especiales, solo letras';
    } else if (values[`charge-name-${index}`].length > 50) {
      errors[`charge-name-${index}`] =
        'El nombre solo puede contener un máximo de 50 caracteres';
    }

    if (!values[`charge-paternal-${index}`]) {
      errors[`charge-paternal-${index}`] = 'Campo obligatorio';
    } else if (!regexString.test(values[`charge-paternal-${index}`])) {
      errors[`charge-paternal-${index}`] =
        'El apellido no puede contener números ni caracteres especiales, solo letras';
    } else if (values[`charge-paternal-${index}`].length > 50) {
      errors[`charge-paternal-${index}`] =
        'El apellido solo puede contener un máximo de 50 caracteres';
    }

    if (!values[`charge-maternal-${index}`]) {
      errors[`charge-maternal-${index}`] = 'Campo obligatorio';
    } else if (!regexString.test(values[`charge-maternal-${index}`])) {
      errors[`charge-maternal-${index}`] =
        'El apellido no puede contener números ni caracteres especiales, solo letras';
    } else if (values[`charge-maternal-${index}`].length > 50) {
      errors[`charge-maternal-${index}`] =
        'El apellido solo puede contener un máximo de 50 caracteres';
    }

    if (!values[`charge-birthdate-${index}`]) {
      errors[`charge-birthdate-${index}`] = 'Campo obligatorio';
    } else if (!regexDate.test(values[`charge-birthdate-${index}`])) {
      errors[`charge-birthdate-${index}`] =
        'Formato de fecha inválido, el formato es dd-mm-aaaa y el año no debe ser menor de 1900';
    }

    if (!values[`charge-gender-${index}`]) {
      errors[`charge-gender-${index}`] = 'Debe seleccionar su género';
    }

    if (!values[`charge-relationship-${index}`]) {
      errors[`charge-relationship-${index}`] = 'Debe seleccionar su parentesco';
    }

    if (values[`charge-relationship-${index}`] === 'CHILDREN') {
      if (!ageValue) {
        errors[`charge-birthdate-${index}`] =
          'Campo obligatorio.';
      } else if (days < 14) {
        errors[`charge-birthdate-${index}`] =
          'La edad mínima asegurable es de 14 días.';
      } else if (years >= 24) {
        errors[`charge-birthdate-${index}`] =
          'El límite de edad asegurable es de 23 años y 364 días.';
      }
    }

    if (values[`charge-relationship-${index}`] === 'SPOUSE') {
      if (!ageValue) {
        errors[`charge-birthdate-${index}`] =
          'Campo obligatorio.';
      } else if (years < 18) {
        errors[`charge-birthdate-${index}`] =
          'Cónyuge o pareja deben ser mayores de 18 años.';
      } else if (years > 59) {
        errors[`charge-birthdate-${index}`] =
          'Cónyuge o pareja deben ser menores de 59 años.';
      }
    }

    return 0;
  });

  return errors;
};

export default validation;
